import { render } from "./IndexModel.vue?vue&type=template&id=023bae38"
import script from "./IndexModel.vue?vue&type=script&lang=js"
export * from "./IndexModel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__